<loader-modal *ngIf="loading"></loader-modal>

<div class="dashboard-filter">
  <div class="flex justify-end pt-2.5">
    <button
      class="ml-4 mr-4 text-link"
      aria-label="Show filters"
      (click)="onSelectFilters()">
      Show filters
      <mat-icon class="material-symbols-rounded orange">arrow_forward</mat-icon>
    </button>
  </div>

  <section class="dashboard-main">
    <div class="dashboard-grid">
      <table [hidden]="loading">
        <tr>
          <th class="profitability-table-header-gray">Profitability</th>
        </tr>
        <tr>
          <th
            class="profitability-table-header-gray"
            colspan="8"
            rowspan="2">
            Estimated
          </th>
          <th
            class="profitability-table-header-gray"
            colspan="4">
            Actual
          </th>
        </tr>
        <tr>
          <th
            colspan="2"
            class="profitability-table-data-blue">
            Time Back In
          </th>
          <th
            class="profitability-table-header-gray"
            colspan="2"></th>
        </tr>
        <tr>
          <th class="profitability-table-header-gray">{{ 'scope' | lang }} ID</th>
          <th class="profitability-table-header-gray">{{ 'scope' | lang }} Name</th>
          <th class="profitability-table-header-gray">Hours scoped</th>
          <th class="profitability-table-header-gray">{{ 'scope' | lang }} Value</th>
          <th class="profitability-table-header-gray">{{ 'scope' | lang }} Cost</th>
          <th class="profitability-table-header-gray">Discounts Applied</th>
          <th class="profitability-table-header-gray">Estimated Margin %</th>
          <th class="profitability-table-header-gray">Estimated Margin {{ currencySymbol }}</th>
          <th class="profitability-table-data-blue">Hours worked</th>
          <th class="profitability-table-data-blue">Cost of time worked</th>
          <th class="profitability-table-header-gray">Margin %</th>
          <th class="profitability-table-header-gray">Margin {{ currencySymbol }}</th>
        </tr>
        <tr *ngFor="let scope of financeReport.scopes">
          <td>{{ scope.id }}</td>
          <td>{{ scope.name }}</td>
          <td>{{ scope.hoursScoped | number }}</td>
          <td>{{ scope.scopeValueRates | currency: currencySymbol }}</td>
          <td>{{ scope.scopeCost | currency: currencySymbol }}</td>
          <td>{{ scope.discountsApplied | currency: currencySymbol }}</td>
          <td>{{ scope.estimatedProfitabilityPercentage }}%</td>
          <td>{{ scope.estimatedProfitability | currency: currencySymbol }}</td>
          <td
            *ngIf="scope.hoursWorked"
            class="profitability-table-data-blue">
            {{ scope.hoursWorked | number }}
          </td>
          <td
            *ngIf="!scope.hoursWorked"
            class="profitability-table-data-blue">
            -
          </td>
          <td
            *ngIf="scope.costOfTimeWorked"
            class="profitability-table-data-blue">
            {{ scope.costOfTimeWorked | currency: currencySymbol }}
          </td>
          <td
            *ngIf="!scope.costOfTimeWorked"
            class="profitability-table-data-blue">
            -
          </td>
          <td *ngIf="scope.profitabilityPercentage">{{ scope.profitabilityPercentage }}%</td>
          <td *ngIf="!scope.profitabilityPercentage">-</td>
          <td *ngIf="scope.profitability">{{ scope.profitability | currency: currencySymbol }}</td>
          <td *ngIf="!scope.profitability">-</td>
        </tr>
        <tr class="font-bold">
          <td>PAGE TOTALS</td>
          <td></td>
          <td>{{ financeReport.total?.hoursScoped | number }}</td>
          <td>{{ financeReport.total?.scopeValueRates | currency: currencySymbol }}</td>
          <td>{{ financeReport.total?.scopeCost | currency: currencySymbol }}</td>
          <td>{{ financeReport.total?.discountsApplied | currency: currencySymbol }}</td>
          <td>{{ financeReport.total?.estimatedProfitabilityPercentage }}%</td>
          <td>{{ financeReport.total?.estimatedProfitability | currency: currencySymbol }}</td>
          <td
            *ngIf="financeReport.total?.hoursWorked"
            class="profitability-table-data-blue">
            {{ financeReport.total?.hoursWorked | number }}
          </td>
          <td
            *ngIf="!financeReport.total?.hoursWorked"
            class="profitability-table-data-blue">
            -
          </td>
          <td
            *ngIf="financeReport.total?.costOfTimeWorked"
            class="profitability-table-data-blue">
            {{ financeReport.total?.costOfTimeWorked | currency: currencySymbol }}
          </td>
          <td
            *ngIf="!financeReport.total?.costOfTimeWorked"
            class="profitability-table-data-blue">
            -
          </td>
          <td *ngIf="financeReport.total?.profitabilityPercentage">
            {{ financeReport.total?.profitabilityPercentage }}%
          </td>
          <td *ngIf="!financeReport.total?.profitabilityPercentage">-</td>
          <td *ngIf="financeReport.total?.profitability">
            {{ financeReport.total?.profitability | currency: currencySymbol }}
          </td>
          <td *ngIf="!financeReport.total?.profitability">-</td>
        </tr>
      </table>
    </div>
  </section>
</div>
<scope-ui-paginator
  class="flex flex-col justify-end mt-2 pr-6"
  [currentPage]="page"
  [totalCount]="totalCount"
  [pageSize]="currentFilters.limit"
  [sizeOptions]="pageSizes"
  (changePage)="onChangePage($event)">
</scope-ui-paginator>
